import apiClient from "./api";

export interface LoginResponse {
  token: string;
  acl: any;
  preferences: any;
  user: {
    id: string;
    username: string;
  };
  language: string;
}

export const loginUser = async (
  username: string,
  password: string
): Promise<LoginResponse> => {
  const espAuthorization = btoa(`${username}:${password}`);

  try {
    const response = await apiClient.get<LoginResponse>("/App/user", {
      headers: {
        "Espo-Authorization": espAuthorization,
        "Content-Type": "application/json",
      },
    });

    const { token } = response.data;
    localStorage.setItem("authToken", token);

    apiClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    return response.data;
  } catch (error) {
    console.error("Login failed:", error);
    throw new Error("Authentication failed");
  }
};

export const updatePassword = async (
  userId: string,
  currentPassword: string,
  newPassword: string
): Promise<void> => {
  const response = await apiClient.put(`/User/${userId}/password`, {
    currentPassword,
    newPassword,
  });
  if (response.status !== 200) {
    throw new Error("Ошибка при смене пароля");
  }
};
